import script from "./add-employee.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-employee.vue?vue&type=script&setup=true&lang=ts"

import "./add-employee.vue?vue&type=style&index=0&id=53e7e236&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e7e236"]])

export default __exports__